module.exports = __webpack_public_path__ + "media/images/pic/hero/saska-kepa-f1e3e8cf698c17bd98a08dc3b866a3f2.webp";